import { useState } from "react";
import { ArrowRight, Building2 } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../auth";
import { Brand } from "../components/Brand";
import { navigate } from "../router";

export function OnboardingPage() {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const auth = useAuth();
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setError("");
    try { await api.createOrganization(name); await auth.refresh(); navigate("/dashboard"); }
    catch (caught) { setError(caught instanceof Error ? caught.message : "Création impossible"); }
  };
  return <div className="onboarding"><header><Brand /></header><form className="onboarding-card" onSubmit={(event) => void submit(event)}><span className="step">Étape 1 sur 2</span><span className="onboarding-icon"><Building2 /></span><h1>Comment s’appelle votre organisation ?</h1><p>Vous pourrez ensuite y rattacher une ou plusieurs exploitations.</p><label>Nom de l’organisation<input autoFocus value={name} onChange={(event) => setName(event.target.value)} minLength={2} required placeholder="Ex. EARL des Amandiers" /></label>{error && <div className="alert error">{error}</div>}<button className="button primary wide">Continuer <ArrowRight size={17} /></button></form></div>;
}
